import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
  token?: string
  isLoggedIn: boolean
}

const initialState: State = {
  token: undefined,
  isLoggedIn: false,
}

interface Action {
  setToken: (token: string | undefined) => void
  removeToken: () => void
  reset: () => void
}

export const useAuthStore = create(
  persist<State & Action>(
    set => ({
      ...initialState,
      setToken: token => set({ token, isLoggedIn: Boolean(token) }),
      removeToken: () => set({ token: undefined, isLoggedIn: false }),
      reset: () => set(initialState),
    }),
    { name: 'auth' },
  ),
)

export const getAuthStore = useAuthStore.getState
